// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-template-modal-body{padding:24px;overflow-y:auto}.create-template-modal-body .create-template-modal-input{margin-bottom:24px}.create-template-modal-body .create-template-modal-input:last-of-type{margin-bottom:32px}.create-template-success-body{padding:30px;display:flex;flex-direction:column;align-items:center;flex:1;justify-content:center}.create-template-success-body>*:not(button){padding-bottom:15px}\n", ""]);
// Exports
module.exports = exports;
